import React, {Component} from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import s from './Rating.scss';

class Rating extends Component {

  static propTypes = {
    count: PropTypes.string,
    rate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.oneOf(['small', 'medium', 'big']).isRequired,
  };

  render() {
    const {count, rate, className} = this.props;
    const ratingStyle = {
      width: `${rate * 20}%`,
    };

    return (
      <div className={cx(s.hbRating, 'hbRatingWrapper')}>
        <div className={`${cx(s.hbRatingContainer, s[className])} hbRating`}>
          <div className={cx(s.rating)} style={ratingStyle}/>
        </div>
        {
          parseInt(count, 10) > 0 &&
          <span className={`${s.hbRatingCount} hbRatingCount`}>({count})</span>
        }
      </div>
    );
  }

}

export default Rating;
